import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67744266"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-item reward-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-item" }, [
  /*#__PURE__*/_createElementVNode("div", null, "可领取奖励")
], -1))
const _hoisted_3 = { class: "block-item" }
const _hoisted_4 = { class: "gift-wrap" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-gift" }, null, -1))
const _hoisted_6 = { class: "gift-info" }
const _hoisted_7 = { class: "gift-name" }
const _hoisted_8 = { class: "gift-desc" }
const _hoisted_9 = { class: "button-wrap" }
const _hoisted_10 = {
  key: 0,
  class: "claimed-btn"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已领取", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "马上领取", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 2,
  class: "un-claim-btn"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "未达成", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips-wrap" }, " *【点击领取】后绑定对应极飞农服账号，并激活对应奖励，奖励使用有效期为一年，过期自动失效。 ", -1))
const _hoisted_20 = { class: "title" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bind-text" }, "绑定设备", -1))
const _hoisted_22 = { class: "input-wrap" }
const _hoisted_23 = { class: "tips" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返  回", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "确  定", -1))
const _hoisted_27 = [
  _hoisted_26
]

import { useStore } from 'vuex'
import { Overlay, Field } from 'vant'
import { receiveReward } from '@/apis/old-brings-new'
import { useOverlayCommonInfo } from '@/compositions/common'
import { withDefaults, ref, computed } from 'vue'
import type { RewardItem, ClaimItem } from '@/types/old-brings-new'
import { showNormalToast, showToastLoading, showToastSuccess } from '@/utils/tools'
import { commonErrorHandle } from '@/utils/error-handle'


export default /*#__PURE__*/_defineComponent({
  __name: 'claim-reward-card',
  props: {
    crrentActiveVal: { default: 0 },
    rewardList: { default: () => [] },
    claimList: { default: () => [] }
  },
  emits: ['receiveSuccess'],
  setup(__props: any, { emit }) {

const props = __props as { crrentActiveVal: number, rewardList: RewardItem[], claimList: ClaimItem[] };



const store = useStore()
const overlayShow = ref(false)
const { overlayHeightValue } = useOverlayCommonInfo()
const currentRewwardType = ref(0) // 当前领取的奖励类型
const bindSn = ref('')
const claimRewardTypeMap = computed(() => {
  const map = new Map()
  ;(props.claimList || []).forEach((item) => {
    map.set(item.reward_id, item)
  })
  return map
})

function getRewardStatus(rewardId: number, invite_num: number) {
  const claimInfo = claimRewardTypeMap.value.get(rewardId)
  if (claimInfo) {
    return 'claimed'
  } else if (props.crrentActiveVal >= invite_num) {
    return 'wait'
  } else {
    return 'unclaim'
  }
}
const rewardGiftList = computed(() => {
  return props.rewardList.map((item, index) => {
    return {
      ...item,
      title: `奖励${index + 1}`,
      value: item.id,
      desc: item.reward_name,
      status: getRewardStatus(item.id, item.invite_num),
    }
  })
})
const rewardDialogBgClass = computed(() => {
  return currentRewwardType.value !== 3 ? 'rewrad-dialog-bg1' : 'rewrad-dialog-bg2'
})
const showBindContent = computed(() => {
  return currentRewwardType.value !== 3
})
const rewardTypeTitle = computed(() => {
  const item = props.rewardList.find((item) => item.id === currentRewwardType.value)
  return item.reward_name
})
const rewardTips = computed(() => {
  return currentRewwardType.value !== 3
    ? '* 确定后，即开始激活使用，有效期为一年。'
    : '* 确定后即为领取成功，折扣券有效期为一年。'
})

function showReceiveContent(value: number) {
  currentRewwardType.value = value
  overlayShow.value = true
}
function hideOverlay() {
  bindSn.value = ''
  overlayShow.value = false
}

// 绑定奖励
async function confirmBindHandle() {
  try {
    if (currentRewwardType.value !== 3 && !bindSn.value) {
      showNormalToast('请输入设备序列号')
      return
    }
    showToastLoading()
    await receiveReward({
      reward_id: currentRewwardType.value + '',
      device_sn: bindSn.value,
      activity_guid: store?.state?.OldBringsNew?.activityGuid,
    })
    hideOverlay()
    showToastSuccess('领取成功')
    setTimeout(() => {
      emit('receiveSuccess')
    }, 1500)
    // 领取成功后刷新数据
  } catch (error) {
    commonErrorHandle(error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rewardGiftList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "gift-item",
              key: index
            }, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.desc), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                (item.status === 'claimed')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                  : (item.status === 'wait')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "wait-btn",
                        onClick: ($event: any) => (showReceiveContent(item.value))
                      }, _hoisted_15, 8, _hoisted_13))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
              ])
            ]))
          }), 128))
        ]),
        _hoisted_19
      ])
    ]),
    _createVNode(_unref(Overlay), {
      show: overlayShow.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((overlayShow).value = $event)),
      class: "reward-overlay",
      style: _normalizeStyle({ height: _unref(overlayHeightValue) })
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["rewrad-dialog-item", _unref(rewardDialogBgClass)])
        }, [
          _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(rewardTypeTitle)), 1),
          (_unref(showBindContent))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_unref(Field), {
                    modelValue: bindSn.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((bindSn).value = $event)),
                    placeholder: "请输入设备序列号"
                  }, null, 8, ["modelValue"])
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(rewardTips)), 1),
          _createElementVNode("div", { class: "button-wrap" }, [
            _createElementVNode("div", {
              class: "back-btn",
              onClick: hideOverlay
            }, _hoisted_25),
            _createElementVNode("div", {
              class: "comfirm-btn",
              onClick: confirmBindHandle
            }, _hoisted_27)
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["show", "style"])
  ], 64))
}
}

})